// import Box from '@mui/material/Box';
// import Card from "@mui/material/Card";
// import CardActionArea from "@mui/material/CardActionArea";
// import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Card from 'components/Card';
import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';

import Fluid from "components/Fluid";
import { ReactComponent as ArrowLeft } from 'images/icons/arrow_left_long.svg';
import { ReactComponent as ArrowRight } from 'images/icons/arrow_right_long.svg';
// import { ReactComponent as CalendarIcon } from 'images/icons/calendar.svg';
// import { ReactComponent as LocationPin } from 'images/icons/map-pin.svg';
import { ReactComponent as ArrowUpRight } from 'images/icons/arrow_up_right.svg';
import Link from 'components/Link';

import 'swiper/css';

const getCardVariant = (slide) => {
    const variantToken = String(
        slide?.variant || slide?.property1 || slide?.cardVariant || slide?.type || ''
    ).toLowerCase().trim();

    if (variantToken === 'variant2' || variantToken === '2') {
        return 'variant2';
    }

    if (variantToken === 'event' || variantToken === 'events') {
        return 'event';
    }

    if (variantToken === 'feature' || variantToken === 'featured' || variantToken === 'featureCard') {
        return 'feature';
    }

    if (variantToken === 'blog' || variantToken === 'blogCard') {
        return 'blog';
    }

    return 'feature';
};

const CardSlider = ({ title, subtitle, slider, slidesPerView = 3.75, cta = null }) => {
    const slides = slider?.slides || [];
    const swiperRef = React.useRef(null);

    if (slides.length === 0) return null;

    return (
        <div className="cardSlider">
            <Fluid layout={{ms: '6', md:'8 4', lg: '10 2'}} className="cardSlider__header">
                <Typography variant="h3" component="div" className="cardSlider__title">
                    {title}
                    {subtitle && <Typography component="span" variant="large" className="cardSlider__subtitle">{subtitle}</Typography>}
                    {cta && <Link className="cardSlider__cta" href={cta?.uri ?? '/'}>{cta?.linkText ?? 'View All'} <span className="cardSlider__cta_icon"><ArrowUpRight /></span></Link>}
                </Typography>
                {slides.length > slidesPerView && <div className="cardSlider__navigation">
                    <button onClick={() => swiperRef.current?.slidePrev()} aria-label="Previous slide">
                        <ArrowLeft />
                    </button>
                    <button onClick={() => swiperRef.current?.slideNext()} aria-label="Next slide">
                        <ArrowRight />
                    </button>
                </div>}
            </Fluid>
            <Fluid layout="12" bleed="right" className="cardSlider__viewport">
                <Swiper
                    className="cardSlider__swiper"
                    spaceBetween={10}
                    slidesPerView={slidesPerView}
                    breakpoints={{
                        0: {
                            slidesPerView: 1.1,
                            spaceBetween: 12,
                        },
                        640: {
                            slidesPerView: 1.55,
                            spaceBetween: 14,
                        },
                        920: {
                            slidesPerView: 2.2,
                            spaceBetween: 16,
                        },
                        1180: {
                            slidesPerView: slidesPerView,
                            spaceBetween: 10,
                        },
                    }}
                    onBeforeInit={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                >
                    {slides.map((slide, index) => {
                        const cardVariant = getCardVariant(slide);
                        return (
                            <SwiperSlide key={index} className={`cardSlider__slide cardSlider__slide--${cardVariant}`}>
                                <Card 
                                    data={slide}
                                    type={cardVariant} />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </Fluid>
        </div>
    );
};

export default CardSlider;